<template>
<footer class="sitewide-footer">

    <section class="pre-footer py-15% vt:py-5% px-4 relative bg-primary-900" :class="{'flex items-center': hideForm}">
        <div class="absolute overflow-hidden bg-primary-800 left-0 top-0 w-full h-full">
            <BackgroundImage parallax="0.1" v-if="footer.data.background_image" :src="footer.data.background_image.src" opacity="0.45"></BackgroundImage>
        </div>
        <div class="max-w-7xl w-full mx-auto relative z-10">
            <div class="grid gap-4 relative">
                <SmoothLoader v-if="footer.data.headline" class="left flex flex-col justify-center">
                    <div class="max-w-4xl mx-auto w-full">
                        <div class="max-w-md">
                            <h2 class="headline text-gray-500 text-4xl vt:text-7xl font-headline font-bold leading-tight text-center vt:text-left my-8 vt:my-0" v-html="footer.data.headline"></h2>
                        </div>
                    </div>
                </SmoothLoader>
                <SmoothLoader class="right" v-if="!hideForm && footer.data.form_embed_code">
                    <h3 v-if="footer.data.form_headline" class="vt:text-white antialiased tracking-wide text-gray-500 text-center text-lg font-headline font-bold uppercase mb-4" v-html="footer.data.form_headline"></h3>
                    <div class="form-box bg-gray-500 rounded-xl p-8 shadow-xl relative z-10">
                        <div class="form-container" v-html="footer.data.form_embed_code"></div>
                    </div>
                </SmoothLoader>
            </div>
        </div>
    </section>
    
    <section class="footer-bottom px-4 relative pt-20% pb-20% vt:pt-5% vt:pb-10% bg-primary-800">

        <div class="max-w-4xl mx-auto">

            <div class="flex justify-center mb-8">
                <a class="logo inline-block" :href="site.url">
                    <img src="/wp-content/themes/landslide/img/footer-logo-white.png" alt="Water for Arizona">
                </a>
            </div>

            <div class="flex justify-center items-center mb-6 vt:mb-12">
                <nav class="top-menu flex flex-wrap items-center justify-center">
                    <div v-for="link in topMenu" class="w-full vt:w-auto text-center mx-4 relative">
                        <a class="menu-link droplet-link relative uppercase font-headline font-bold text-white text-xs tracking-wider" :href="link.href">
                            {{ link.name }}
                        </a>
                        <span class="accent absolute text-primary-400" aria-hidden="true">
                            <i class="fa-solid fa-droplet"></i>
                        </span>
                    </div>
                    <SocialLinks :links="site.social_media" class="w-full relative z-10 mt-6"></SocialLinks>
                </nav>
            </div>

            <div class="flex justify-center mb-8">
                <nav class="bottom-menu flex flex-wrap items-center justify-center">
                    <div v-for="link in bottomMenu" class="w-full vt:w-auto text-center mx-4 relative">
                        <Link class="menu-link relative uppercase font-headline font-bold text-primary-600 text-xs tracking-wider transition-colors hover:text-secondary-500 focus:text-secondary-500" :href="link.href">
                            {{ link.name }}
                        </Link>
                    </div>
                </nav>
            </div>

            <div class="text-center">
                <p class="text-gray-700" v-html="footer.data.copyright"></p>
            </div>
            
        </div>

    </section>
</footer>
</template>

<script>
import SocialLinks from './Utilities/SocialLinks.vue';
export default {

    props: {
        context: {
            required: true
        },
        hideForm: {
            default: false
        }
    },

    setup(props) {
        return {
            hideForm: props.context.content.hide_footer_form,
            topMenu: props.context.nav?.footer_menu || [],
            bottomMenu: props.context.nav?.footer_bottom_menu || [],
            ...props.context,
        }
    },

    components: {
        SocialLinks
    }

}
</script>
